import {Badge} from "@mantine/core";
import {BillingChannel, ReconciliationReport} from "../types.ts";
import {hasDiscrepancies, totalDiscrepancies} from "../utils/discrepancyHealth.ts";

// The billing channel a run targeted.
export const ChannelBadge = ({channel}: { channel: BillingChannel | string }) => {
    let color = 'gray';
    if (channel === 'STRIPE') {
        color = 'indigo';
    } else if (channel === 'AWS_MARKETPLACE') {
        color = 'orange';
    } else if (channel === 'INTERNAL') {
        color = 'gray';
    }
    return <Badge color={color}>{channel}</Badge>;
};

// Health badge for a reconciliation run. Green when our billing matched the channel
// exactly (no discrepancies); red with the count when something didn't reconcile —
// the "look here when a customer disputes a charge" signal.
export const DiscrepancyBadge = ({record}: { record: ReconciliationReport }) => {
    if (hasDiscrepancies(record)) {
        return <Badge color={'red'}>{totalDiscrepancies(record)} discrepanc{totalDiscrepancies(record) === 1 ? 'y' : 'ies'}</Badge>;
    }
    return <Badge color={'green'}>Reconciled</Badge>;
};
